import RegexUtils from '../../../utils/RegexUtils';
import AccountPoolsConstant from '../../../constants/AccountPoolsConstant';

export const removeError = (key, errors) => {
  const newErrors = errors.filter((error) => error.key !== key);
  return newErrors;
};

export const getErrorMessage = (key, errors) => {
  const error = errors.find((error) => error.key === key);
  return (error && error.errorMessage) || '';
};

export const removeErrors = () => {
  return [];
};

export const validateField = (errors, value, content, key) => {
  let newErrors = errors || [];
  const {
    errorMessages: { poolNameInvalidErrorMessage },
  } = content;
  if (value && !RegexUtils.isValid(value, RegexUtils.regexes.poolNameRegex)) {
    newErrors.push({ key: key, errorMessage: poolNameInvalidErrorMessage });
  } else {
    newErrors = removeError(key, newErrors);
  }
  return newErrors;
};

export const validateFields = (state, content) => {
  const { accountPoolName, popularNotionalCurrency, notionalCurrency } = state;
  let newErrors = [];
  const {
    errorMessages: {
      poolNameEmptyErrorMessage,
      poolNameInvalidErrorMessage,
      popularNotionalCurrencyMessage,
      notionalCurrencyMessage,
    },
  } = content;
  if (!accountPoolName) {
    newErrors.push({
      key: AccountPoolsConstant.POOL_NAME_KEY,
      errorMessage: poolNameEmptyErrorMessage,
    });
  }
  if (
    accountPoolName &&
    !RegexUtils.isValid(accountPoolName, RegexUtils.regexes.poolNameRegex)
  ) {
    newErrors.push({
      key: AccountPoolsConstant.POOL_NAME_KEY,
      errorMessage: poolNameInvalidErrorMessage,
    });
  }
  if (!popularNotionalCurrency) {
    newErrors.push({
      key: AccountPoolsConstant.POPULAR_CURRENCY_KEY,
      errorMessage: popularNotionalCurrencyMessage,
    });
  }
  if (popularNotionalCurrency === 'other' && !notionalCurrency) {
    newErrors.push({
      key: AccountPoolsConstant.CURRENCY_SELECT_KEY,
      errorMessage: notionalCurrencyMessage,
    });
  }
  return newErrors;
};
